import { initialProps } from '@utils/initial'
import { routes } from '@group-devs/yfp7-global-modules/data/lcw'

import Error from 'next/error'
import Head from 'next/head'
import { Discover, TourHeader, TourContent } from '@components/Block'

export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query, routes.ds)
    }
}

const DiscoverTour = (props) => {
    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />
        
    return (
        <Discover global={props}>
            <Head><title>Discover Shaklee - Tour</title></Head>
            <TourHeader/>
            <TourContent site={props}/>
        </Discover>
    )
}

export default DiscoverTour